import { makeApiAction } from './actions';
import * as type from './types';
import { potentialRevenues } from '../graphql/queries';

export const fetchPotentialRevenuesAction = () => (dispatch) => {
  const action = 'FETCH_POTENTIAL_REVENUES';

  dispatch(
    makeApiAction(action, potentialRevenues, { filter: 'all' }, null, 'potentialRevenues', true),
  );
};

export const clearPotentialRevenuesAction = () => (dispatch) => {
  dispatch({
    type: type.CLEAR_POTENTIAL_REVENUES,
  });
};
